var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { FontEditor } from '../ts/tools/FontEditor';
import { Carousel } from './Carousel';
import { StoryLinks } from './StoryLinks';
export class AjaxLoader extends Component {
    constructor() {
        super('AjaxLoader', true);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            AjaxLoader.isItemOpened = false;
            this.originalTitle = document.title;
            this.siteTitle = this.originalTitle.split('-')[1];
            AjaxLoader.originalURL = location.href;
            $(window).on('popstate', (event) => {
                this.manageState(event.state);
            });
            $('body').on('click', '.preview-default', (event, item) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                var href = item.attr('href').replace(location.protocol + '//' + location.host, '');
                var title = item.find('h1').text() + ' - ' + this.siteTitle;
                var data = {
                    action: 'open',
                    title: title,
                    id: $(item).attr('id'),
                    target: $(event.target).data('target')
                };
                AjaxLoader.originalURL = location.href;
                this.pushState(data, title, href);
            }));
            this.success();
        });
    }
    manageState(data) {
        if (!data) {
            $('.preview').removeClass('expanded');
            $('.font-editor').forEach((fontEditor) => {
                fontEditor.remove();
            });
            $('article').forEach((article) => {
                article.remove();
            });
        }
        else if (data.action == 'open') {
            AjaxLoader.isItemOpened = true;
            this.open($('#' + data.id), data.target);
            document.title = data.title;
            $('.filters').addClass('inactive');
        }
        else if (data.action == 'close') {
            AjaxLoader.isItemOpened = false;
            this.close($('#' + data.id).parents('.preview'));
            $('.filters').removeClass('inactive');
        }
    }
    open(item, target) {
        return __awaiter(this, void 0, void 0, function* () {
            const type = (item.parent().hasClass('preview-product')) ? 'product' : 'article';
            item.parent().addClass('loading');
            var elementHTML = yield $.httpRequest({
                url: item.attr('href'),
                type: 'POST',
                body: {
                    'partial': true
                },
                dataType: 'html',
            });
            item.parent().addClass('expanded').append(elementHTML);
            if (type == 'article') {
                StoryLinks.initArticleLinks(elementHTML.get(0));
                yield $.imagesLoaded(elementHTML.find('img'));
                elementHTML.find('.carousel').forEach((carousel) => {
                    Carousel.initCarousel(carousel);
                    Carousel.fixButtonsTop(carousel);
                    Carousel.fixCaptionHeight(carousel);
                });
                if ($('.button-display-grid').hasClass('active'))
                    item.parent().removeClass('col-8').addClass('col-16');
            }
            else {
                new FontEditor(elementHTML.get(0), target);
            }
            elementHTML.find('.button-close').on('click', (event, button) => {
                event.preventDefault();
                var title = item.find('h1').text() + ' - ' + this.siteTitle;
                var data = {
                    action: 'close',
                    title: this.originalTitle,
                    id: $(item).attr('id')
                };
                this.pushState(data, title, AjaxLoader.originalURL);
            });
            item.parent().removeClass('loading');
        });
    }
    close(parent) {
        if (parent.hasClass('preview-product')) {
            parent.find('.font-editor').get(0).remove();
        }
        else {
            parent.find('article').get(0).remove();
            if ($('.button-display-grid').hasClass('active'))
                $('.preview-article').removeClass('col-16').addClass('col-8');
        }
        parent.removeClass('expanded');
    }
    pushState(data, title, href) {
        if (typeof FWP != 'undefined')
            FWP.is_refresh = true;
        history.pushState(data, title, href);
        var popStateEvent = new PopStateEvent('popstate', { state: data });
        dispatchEvent(popStateEvent);
    }
}
